import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { monthlyReportHandler } from "./store/monthlyReportSlice";
import MonthlyReportList from "./screen/MonthlyReportList";
import { updateNavbarHeading } from "../../../constants/layout/store/filterSlice";
import { injectReducer } from "../../../store/store";
import monthlyReportReducer from "./store";

const MonthlyReport = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    // Inject the reducer when component mounts
    injectReducer('monthlyReport', monthlyReportReducer);
    
    // Dispatch actions
    dispatch(monthlyReportHandler());
    dispatch(updateNavbarHeading("Monthly Report"));
  }, [dispatch]);

  return (
    <div className="container-fluid" id="skill_section">
      <MonthlyReportList />
    </div>
  );
};

export default MonthlyReport;